import { render, staticRenderFns } from "./VeiculosEspeciais.vue?vue&type=template&id=78e204ae&"
import script from "./VeiculosEspeciais.vue?vue&type=script&lang=js&"
export * from "./VeiculosEspeciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports